import {Component, Input} from '@angular/core';

import {Router} from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSurvey } from '../modals/components/modalSurvey/modalSurvey.component';
import { ModalSurveyPlan } from '../modals/components/modalSurveyPlan/modalSurveyPlan.component';
import { ModalGeneralConfig } from '../modals/components/modalGeneralConfig/modalGeneralConfig.component';
import { ModalUser } from '../modals/components/modalUser/modalUser.component';
import { ModalEditUser } from '../modals/components/modalEditUser/modalEditUser.component';

@Component({
  selector: 'ba-card',
  templateUrl: './baCard.html',
})
export class BaCard {
  @Input() cardTitle:String;
  @Input() baCardClass:String;
  @Input() cardType:String;
  @Input() withAddButton:Boolean = false;
  @Input() withReturnButton:Boolean = false;
  @Input() urlReturn = '';
  @Input() type:String;
  @Input() buttonLabel:string = '';

  @Input() isDisabled: boolean = false;

  constructor(
              private _modalService: NgbModal,
              private _router: Router
  ){

  }

  private openModal(){
  	var activeModal;
    switch(this.type){
      case 'surveyPlan':
        activeModal = this._modalService.open(ModalSurveyPlan, {size: 'lg'});
        break;
      case 'configParam':
        activeModal = this._modalService.open(ModalGeneralConfig, {size: 'lg'});
        break;
      case 'user':
        activeModal = this._modalService.open(ModalUser, {size: 'lg'});
        break;        
      default:
        activeModal = this._modalService.open(ModalSurvey, {size: 'lg'});
    }

  	activeModal.componentInstance.modalHeader = 'Agregar';
  }

  private return(){
    this._router.navigateByUrl(this.urlReturn);
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/baCard/baCard.component.ts